import noneRuntime_36M62ltpquQFTA0E63US6rtv7NOCt4xfmxuw2wMqtvI94 from '/home/snaumann/Development/public_html/valere/site/node_modules/.pnpm/@nuxt+image@2.1.0_@types+node@24.13.6_magic-string@1.4.1_magicast@0.5.5_rolldown@1.2.9__b3770ef603b22cde52b9208b399be376/node_modules/@nuxt/image/dist/runtime/providers/none'
import gsRuntime_36UouP_j5xURnQM9WpwSK8K8ZrU3b8Clz7qfcLxLYrdGM from '/home/snaumann/Development/public_html/valere/api/vendors/gsmaterials/imgProvider.ts'

export const imageOptions = {
  screens: {"sm":640,"md":768,"lg":1024,"xl":1280,"2xl":1536},
  presets: {},
  domains: [],
  alias: {},
  densities: [1,2],
  format: ["webp"],
  quality: undefined,
  /** @type {"none"} */
  provider: "none",
  providers: {
      ['none']: { setup: noneRuntime_36M62ltpquQFTA0E63US6rtv7NOCt4xfmxuw2wMqtvI94, defaults: true },
  ['gs']: { setup: gsRuntime_36UouP_j5xURnQM9WpwSK8K8ZrU3b8Clz7qfcLxLYrdGM, defaults: undefined }
  }
}
